/**
 * Cart page — repaints itself after a change.
 *
 * The quantity and remove controls are handled by cart.js. This only listens
 * for the result: the page's own section comes back rendered in the same
 * request (see cart.js), and the whole block is swapped for it.
 */
(function () {
  'use strict';

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function page() {
    return document.querySelector('[data-cart-page]');
  }

  function render(html) {
    const current = page();
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]');
    if (!current || !next) return;
    if (window.Cart) window.Cart.swap(current, next);
    else current.replaceWith(next);
  }

  document.addEventListener('cart:updated', async (event) => {
    const current = page();
    if (!current) return;
    const id = current.dataset.cartSection;
    const html = event.detail && event.detail.sections && event.detail.sections[id];
    if (html) {
      render(html);
      return;
    }
    // An update that didn't carry this section (a card add from elsewhere on
    // the page, say): fetch it. The cart page is a JSON-template section, so
    // it only renders at its own URL.
    try {
      // Plain GET: with Accept: application/json, /cart answers with the cart's
      // JSON and ignores ?sections=.
      const res = await fetch(`${root()}cart?sections=${encodeURIComponent(id)}`);
      if (!res.ok) return;
      const json = await res.json();
      if (json[id]) render(json[id]);
    } catch {
      /* leave the page as it is */
    }
  });
})();
